import { render, staticRenderFns } from "./HomeRecipeCard.vue?vue&type=template&id=68dad9dd"
import script from "./HomeRecipeCard.vue?vue&type=script&lang=js"
export * from "./HomeRecipeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeRecipeCard.vue?vue&type=style&index=0&id=68dad9dd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports